var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "warning__step__icon",
      attrs: {
        src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAkCAYAAAD7PHgWAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANhSURBVHgBzZhPTttAFMbfG6f/0i6yLJSFCd1UlEq9QbhBewLgBNATJDlB4ASEE5QbwA2KCKiLgnCl0naHK7WoLfFM37M9yRBsx2MblU+yMs5M7C/feH5+NkCFOmo+6w2asx2oUAgV6aP71A0cccZtJ5DzL7zvHlQgARXpysGObgeOsw0VqZIEB+5cCx25x20F4NNBGwrF8tLJl30oqUoSFEKGiSmELjnc4jYq1YYKVNrg8cKzVTLmUmpebSj7Q3l/k1Mkuy3ug5Iqn+AoKezywnjteT4iduPO9pnbaEAJlTJ43Jxt6/QWT8/7+vuXJ+ebqMCjJN2for4BJVTYIGOFPlajPZ3YWFKItbAHYb1MioUNMlbi9HbN9LSiFYy0QeOXeFR4wRQyyOkJwJXwAIF8lzZO6WsRcSNO3FqFDBpQ7mfdMThFCWqH20XhbW3w0J15o9OjW1p32vggeLChsTN4PtcCS9XAUo7AHp0whLKZ3iTz9HXJ2KECYovuWe0Y3vtgIasETSg/GV5umn00lWRcbcdbz+wrA+/cBkNUGFCe93z/2oEUjPaZgWafCW82b4Od3AYvRX09CcpatGI9o+1P9jO8qeOAmg0beOcyyIggcx1uB6ASsSKl/DzeUz+SxiiB4W9t4J3LoImVV6ffdpPGIApjisdpmroGb6fegyoMmlDOwgpPvW4rkF7qOAF6BlbzYGeqQQOwmVCmaRslKBBSxy1+Oj9QgLlrxkyDERJUi9OZBmUZjKc1QMfPGjsM7nXywjs7wfgfSoSdaQ9BNRiO+sXwT6ZBxo6uvIWS24UMmlBeOvnagSn6DQ995h9vdbjypo1neOua8ag5k4qdxIcmXhhUz+1FBnEtiXtVKAyB7jzU9B8Hl/OT8GclJkjmVrKgnCZmm81dIjp2hJ00eN8waEJZYlQV5xGX/8S2C96ypmxSumZkeCfVjDcMmlC2ea7Vfwqis+WuoE1405uJdqbBvFBONAhGsWC088gJAj1TN+B9zWAgnPdxs2/7boUu9jUuBmhlHhCp39r8ls+VBu/RKtYrihcGPWcsV/XyJ68+uG6j5vw9m3xtMk7QAsq3oTR4hwZtoXxbMuGt3zOKcGkblTL8R4UpGthhpuLhwkxfr9y7JqWgi4OF2Qu+MOEOii+5f5s3u2VIJhn1AAAAAElFTkSuQmCC",
      },
    }),
    _vm._v(" "),
    _c("h1", { staticClass: "warning__step__title" }, [
      _vm._v("\n    " + _vm._s(_vm.title) + "\n  "),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "warning__step__description" }, [
      _vm._v("\n    " + _vm._s(_vm.description) + "\n  "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }